import React from 'react';
import { useSelector } from 'react-redux';

import {
  FETCH_STATUS_FAILED,
  FETCH_STATUS_NONE,
  FETCH_STATUS_PENDING,
  FETCH_STATUS_SUCCESS,
  FetchStatus,
} from '@neptune/shared/common-domain';
import { backendClient } from '@neptune/shared/core-apis-backend-domain';

import { isUserAuthenticated } from 'state/users/current-user/selectors';

type UseApiTokenValue = {
  token?: string;
  error?: any;
  status: FetchStatus;
  refetchToken(): void;
};

export const useApiToken = (deps: any[] = []): UseApiTokenValue => {
  const [apiToken, setApiToken] = React.useState<string | undefined>();
  const [status, setStatus] = React.useState<FetchStatus>(FETCH_STATUS_NONE);
  const [error, setError] = React.useState<unknown>();
  const [lastFetchTimestamp, setLastFetchTimestamp] = React.useState<number | undefined>();
  const isAuthenticated = useSelector(isUserAuthenticated);

  async function fetchToken() {
    setError(undefined);
    setStatus(FETCH_STATUS_PENDING);

    try {
      const response = await backendClient.getApiToken();
      setApiToken(response.token);
      setStatus(FETCH_STATUS_SUCCESS);
    } catch (error) {
      setError(error);
      setStatus(FETCH_STATUS_FAILED);
    }
  }

  React.useEffect(() => {
    if (isAuthenticated) {
      fetchToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, isAuthenticated, lastFetchTimestamp]);

  function refetchToken() {
    setLastFetchTimestamp(Date.now());
  }

  return {
    token: apiToken,
    error,
    refetchToken,
    status,
  };
};
